// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Kvyn","left":"styles_left__5vaZn"};